<script lang="ts" setup>
import nameLogo from '~/assets/icons/logo/name.svg?url';
</script>

<template>
  <section class="contactsHeader">
    <NuxtLink to="/">
      <img :src="nameLogo" alt="Don't Touch My Skin" class="contactsHeader__logo" />
    </NuxtLink>
  </section>
</template>

<style lang="scss">
.contactsHeader {
  display: flex;
  align-items: center;
  padding: 30px 20px;
  background-color: #ffffff;

  &__logo {
    width: 161px;
    filter: invert(1);

    @include mq('sm') {
      width: 121px;
    }
  }
}
</style>
